import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=47f8d7d0&scoped=true"
import script from "./sale.vue?vue&type=script&lang=js"
export * from "./sale.vue?vue&type=script&lang=js"
import style1 from "./sale.vue?vue&type=style&index=1&id=47f8d7d0&prod&lang=scss"
import style2 from "./sale.vue?vue&type=style&index=2&id=47f8d7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8d7d0",
  null
  
)

export default component.exports